<template>
  <div class="menubuilder__tselector">
    <h3>
      <input type="text" name="menubuilder__othertitle" class="menubuilder__othertitle" v-model="extrasTitle.value" />
      <label class="menubuilder__edit">
        <span class="help-icon" @click="toggleTooltip()">?</span>
        <span class="tooltip" v-bind:class="{ active: showTooltip }">
          {{extrasHelpText.value}}
        </span>
      </label>
    </h3>
    <ul>
      <li v-for="(extra, index) in extras" :key="index">
        <span class="plus" @click="remove(extra)"><span>-</span></span>
        <input class="menubuilder__ttitle" v-model="extra.name" />
        <input type="text" class="menubuilder__tprice" v-model="extra.price" />
      </li>
    </ul>
    <div class="menubuilder__add" @click="addExtra">
      <span class="plus"><span>+</span></span>
      <span>Add an extra</span>
    </div>
  </div>
</template>


<script>
  export default {

    data: function () {
      return {
        showTooltip: false,
        extrasTitle: this.$store.state.extrasTitle,
        extras: this.$store.state.extras,
        extrasHelpText: this.$store.state.extrasHelpText
      };
    },
    computed: {
    },
    props: ['defaultExtra'],
    methods: {
      addExtra() {
        this.$store.addExtra('New Product', this.$store.state.newProductPrice.value)
      },
      remove(extra){
        this.$store.removeExtra(extra)
      },
      toggleTooltip() {
        this.showTooltip = !this.showTooltip;
      }
    },
    computed: {
    },
    async mounted() {

    }
  }

</script>


<style lang="sass">
@import "../../../../styles/partials/variables"

.menubuilder
  &__edit
    position: relative

    .tooltip
      opacity: 0
      visibility: hidden
      display: inline-block
      position: absolute
      top: calc(100% + 6px)
      left: 50%
      transform: translate3d(-50%, 0, 0)
      width: 100px
      text-transform: none
      background: black
      color: #ffffff
      line-height: 1.1
      padding: 6px
      font-weight: normal
      border-radius: 6px
      text-align: center
      z-index: 1

      &:before
        content: ''
        display: inline-block
        width: 0
        height: 0
        border-style: solid
        border-width: 0 8px 6px 8px
        border-color: transparent transparent #000000 transparent
        position: absolute
        left: 50%
        bottom: 100%
        transform: translate3d(-50%, 0, 0)

      &.active
        opacity: 1
        visibility: visible

    .help-icon
      background: $color-grey
      border-radius: 100%
      color: #ffffff
      cursor: pointer
      display: inline-block
      height: 20px
      line-height: 20px
      text-align: center
      width: 20px

</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/ExtrasSelector.vue